import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RViewHelpernvzwiwlyoaxk as RViewHelper } from './RViewHelper.mjs';
import {
  FutureElement3o36ukl4wk2br as FutureElement,
  nativeSetDragDatar0aostqx6mw0 as nativeSetDragData,
  nativeOnDropqd3pwmgl0tbk as nativeOnDrop,
  nativeScrollIntoView1kvjsy2ddtc83 as nativeScrollIntoView,
} from './RView.commonHtml.js.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './direct/ContainingView.commonHtml.mjs';
import {
  _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr,
  Dimensions32ju1l7z4mh as Dimension,
} from '../models/data.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../afterTimeout.mjs';
import { WeakReferencel11chldcck68 as WeakReference } from '../debugger.js.mjs';
import { checkLeakAfterDelayr9e6vxihbhwn as checkLeakAfterDelay } from '../debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.vb3_1 = 0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var RViewClass;
function RView() {
  if (RViewClass === VOID) {
    class $ extends RViewHelper() {
      constructor(context) {
        super(context);
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = new (FutureElement())();
        this_0.jb4_1.v('kui');
        tmp.vb5_1 = this_0;
        this.wb5_1 = true;
        this.xb5_1 = null;
        var tmp_0 = this.fb7();
        tmp_0.vah(() => {
          if (this.fb7().f2())
            this.vb5_1.jb4_1.v('working');
          else
            this.vb5_1.jb4_1.w3('working');
          return Unit_instance;
        });
      }
      gb7(value) {
        super.gb7(value);
        var tmp0 = this.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.opacity' call
        var value_0 = value.toString();
        tmp0.hb7_1.opacity = value_0;
      }
      ib7() {
        return super.ib7();
      }
      jb7(value) {
        super.jb7(value);
        var tmp0 = this.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        var value_0 = !value;
        tmp0.kb7_1.hidden = value_0;
        var tmp = this.tb6_1;
        var tmp0_safe_receiver = tmp instanceof RowOrCol() ? tmp : null;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.xb8();
        }
      }
      yb8() {
        return super.yb8();
      }
      zb8(value) {
        super.zb8(value);
        var tmp0 = this.vb5_1.db4_1;
        // Inline function 'com.lightningkite.kiteui.views.visibility' call
        var value_0 = value ? 'visible' : 'hidden';
        tmp0.hb7_1.visibility = value_0;
      }
      ab9() {
        return super.ab9();
      }
      bb9(value) {
        super.bb9(value);
        var tmp = this.vb5_1;
        var tmp_0;
        var tmp_1 = value;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _Dimension___get_value__impl__urhqzr(value);
        }
        var tmp1_safe_receiver = tmp_0;
        tmp.cb9('--spacing', tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString());
      }
      db9() {
        return super.db9();
      }
      eb9(value) {
        super.eb9(value);
        if (value)
          this.vb5_1.jb4_1.v('noInteraction');
        else
          this.vb5_1.jb4_1.w3('noInteraction');
      }
      fb9(value) {
        super.fb9(value);
        var tmp = this.vb5_1;
        tmp.gb9('data-debug-name', value == null ? '' : value);
      }
      hb9() {
        return super.hb9();
      }
      ib9(value) {
        super.ib9(value);
        var tmp0 = this.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.draggable' call
        var value_0 = !(value == null);
        tmp0.kb7_1.draggable = value_0;
        if (!(value == null)) {
          var tmp0_0 = this.vb5_1.jb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = 'draggable';
          tmp0_0.v(element);
        } else {
          var tmp0_1 = this.vb5_1.jb4_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element_0 = 'draggable';
          tmp0_1.w3(element_0);
        }
        nativeSetDragData(this, value);
      }
      jb9() {
        return super.jb9();
      }
      kb9(value) {
        super.kb9(value);
        nativeOnDrop(this, value);
      }
      lb9() {
        return super.lb9();
      }
      mb9() {
        super.mb9();
        if (!(this.ob9() == null) || !(this.hb6_1 == null)) {
          var value = this.nb9();
          var tmp0 = this.vb5_1.db4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingLeft' call
          var value_0 = _Dimension___get_value__impl__urhqzr(value.mb2_1).toString();
          tmp0.hb7_1.paddingLeft = value_0;
          var tmp0_0 = this.vb5_1.db4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingTop' call
          var value_1 = _Dimension___get_value__impl__urhqzr(value.nb2_1).toString();
          tmp0_0.hb7_1.paddingTop = value_1;
          var tmp0_1 = this.vb5_1.db4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingRight' call
          var value_2 = _Dimension___get_value__impl__urhqzr(value.ob2_1).toString();
          tmp0_1.hb7_1.paddingRight = value_2;
          var tmp0_2 = this.vb5_1.db4_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingBottom' call
          var value_3 = _Dimension___get_value__impl__urhqzr(value.pb2_1).toString();
          tmp0_2.hb7_1.paddingBottom = value_3;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.paddingLeft' call
          this.vb5_1.db4_1.hb7_1.paddingLeft = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingTop' call
          this.vb5_1.db4_1.hb7_1.paddingTop = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingRight' call
          this.vb5_1.db4_1.hb7_1.paddingRight = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingBottom' call
          this.vb5_1.db4_1.hb7_1.paddingBottom = null;
        }
      }
      pb9(horizontal, vertical, animate) {
        return nativeScrollIntoView(this, horizontal, vertical, animate);
      }
      qb9() {
        this.vb5_1.gb9('autofocus', 'true');
        afterTimeout(this, 100n, () => {
          this.vb5_1.rb9();
          return Unit_instance;
        });
      }
      sb9() {
        checkLeakAfterDelay(new (WeakReference())(this.vb5_1), 1000n);
        var tmp0_safe_receiver = this.vb5_1.tb9();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          checkLeakAfterDelay(new (WeakReference())(tmp0_safe_receiver), 1000n);
        }
      }
      ub9(theme) {
        if (theme.hb1_1) {
          this.vb5_1.jb4_1.v('transition');
        } else {
          this.vb5_1.jb4_1.w3('transition');
        }
        if (theme.ib1_1) {
          this.vb5_1.jb4_1.v('padded');
        } else {
          this.vb5_1.jb4_1.w3('padded');
        }
        var tmp0_safe_receiver = this.xb5_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.vb5_1.jb4_1.w3(tmp0_safe_receiver);
        }
        var newClass = this.pc().qb3_1.cb2(theme.gb1_1);
        this.xb5_1 = newClass;
        this.vb5_1.jb4_1.v(newClass);
        var tmp = this.vb5_1;
        var tmp1_safe_receiver = this.tb6_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.vb9();
        var tmp_0;
        var tmp_1 = tmp2_safe_receiver;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _Dimension___get_value__impl__urhqzr(tmp2_safe_receiver);
        }
        var tmp3_safe_receiver = tmp_0;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
        tmp.cb9('--parentSpacing', tmp4_elvis_lhs == null ? '0px' : tmp4_elvis_lhs);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.flushClasses' call
        this.vb5_1;
      }
      wb9(index, view) {
        this.vb5_1.xb9(index, view.vb5_1);
      }
      yb9(index) {
        this.vb5_1.zb9(index);
      }
      aba() {
        this.vb5_1.bba();
      }
    }
    initMetadataForClass($, 'RView');
    RViewClass = $;
  }
  return RViewClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RView as RView1jxdnn5qf89cm,
};
//endregion

//# sourceMappingURL=RView.commonHtml.mjs.map
